import { gql } from "@apollo/client";

export const ONBOARD_USER_SIMPLE = gql`
  mutation OnboardUserSimple(
    $firstName: String!
    $lastName: String!
    $email: String!
    $contactPhoneNumber: String!
    $activityPhoneNumber: String!
    $timeZone: String!
    $leadType: String
    $specialistId: Int!
    $Id_Ehr: String!
    $isTestUser: Boolean!
  ) {
    createAccount(
      data: {
        firstName: $firstName
        lastName: $lastName
        email: $email
        contactPhoneNumber: $contactPhoneNumber
        activityPhoneNumber: $activityPhoneNumber
        timeZone: $timeZone
        specialistId: $specialistId
        isTestUser: $isTestUser
        leadType: $leadType
        Id_Ehr: $Id_Ehr
      }
    ) {
      id
    }
  }
`;

export const QUERY_RESPONSE = gql`
  query GetAddUserPopupSpecialists {
    specialists {
      id
      firstName
    }
  }
`;
